<template lang="pug">
	
	.quote
		slot(name="quote")
		slot(name="translation")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'


  	@Component({
		name: 'Quote',
		components: { }
	})

	class Quote extends Vue {

		// mounted () {
		// 	super.mounted()

		// 	this._dom()
		// }

		// init () {
		// 	super.init()

		// }

		// _bind () {
		// 	super._bind()
		// }

		// _dom () {
		
		// }

		// _intervals () {
			
		// }

		// _points () {

		// } 

		// _resize () {
		// 	super._resize()

		// 	this._intervals()
		// 	this._points()
		// }

		// _on () {
		// 	super._on()
		// }

		// _off () {
		// 	super._off()
			
		// }

	}

	export default Quote

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.quote
		width 100%			
		

		blockquote
			color #fff
			font-size em(30px)
			line-height em(40px,30px)
			font-family $FONT_PRIMARY
			letter-spacing .01em

			+break(xs)
				font-size em(24px)
			
		.translation
			color #fff
			font-size em(15px)
			line-height em(21px,15px)
			letter-spacing .15em
			font-family $FONT_SECONDARY
			font-weight 300
			text-transform uppercase
			margin-top 8px

</style>


// WEBPACK FOOTER //
// quote.vue?46291115